/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Example_HeadingInputs */

const ja_playdata_pricing_example_heading = /** @type {(inputs: Playdata_Pricing_Example_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金の例：LJL 2022 summer splitの場合`)
};

const en_playdata_pricing_example_heading = /** @type {(inputs: Playdata_Pricing_Example_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example: LJL 2022 Summer Split`)
};

/**
* | output |
* | --- |
* | "Example: LJL 2022 Summer Split" |
*
* @param {Playdata_Pricing_Example_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_example_heading = /** @type {((inputs?: Playdata_Pricing_Example_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Example_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_example_heading(inputs)
	return en_playdata_pricing_example_heading(inputs)
});